<template>
  <div @click="toggleBasket()" class="toggle-basket btn btn-secondary no-text" id="toggle-basket-wrapper">
    <div id="toggle-basket">
      <i class="far fa-shopping-basket"></i>
      <span id="toggle-basket-text" v-if="basket">{{ basket.total_quantity }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //
    };
  },

  props: {
    basket: {
      type: Object,
    },
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    toggleBasket() {
      this.$root.showMiniBasket = !this.$root.showMiniBasket;
    }
  },
};
</script>
